export function resolveBlogPostUpdatedAt(bodyTime: unknown, publishedAt: unknown): string {
    const bodyTimestamp = typeof bodyTime === 'number' && Number.isFinite(bodyTime) && bodyTime > 0
        ? bodyTime
        : 0;
    const parsedPublishedAt = typeof publishedAt === 'string' ? Date.parse(publishedAt) : NaN;
    const publishedTimestamp = Number.isFinite(parsedPublishedAt) ? parsedPublishedAt : 0;
    const resolvedTimestamp = Math.max(bodyTimestamp, publishedTimestamp);

    return resolvedTimestamp ? new Date(resolvedTimestamp).toISOString() : '';
}
